import { format, fromUnixTime } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

// Centralized date / time format strings for the Brazilian Portuguese (pt-BR)
// standard. Every calendar / date picker / date display in the app should
// import from this module so the formatting stays consistent in a single place.

// date-fns format tokens (used with date-fns `format()`)
export const DATE_FORMAT = 'dd/MM/yyyy';
export const DATE_FORMAT_SHORT = 'dd MMM';
export const DATE_FORMAT_LONG = 'dd MMM yyyy';
export const DATETIME_FORMAT = 'dd/MM/yyyy HH:mm';
export const DATETIME_FORMAT_LONG = 'dd MMM yyyy, HH:mm';
export const DATETIME_SHORT_TIME = 'dd MMM, HH:mm';
export const TIME_FORMAT = 'HH:mm';
export const FILENAME_DATE_FORMAT = 'dd-MM-yyyy';

// vue-datepicker-next uses uppercase tokens (dayjs-like)
export const VDP_DATE_FORMAT = 'DD/MM/YYYY';
export const VDP_DATETIME_FORMAT = 'DD/MM/YYYY HH:mm';

// pt-BR locale object for date-fns (re-exported so callers don't import it directly)
export const dateFnsLocale = ptBR;

// Brazilian week day labels for the custom calendar (Sunday-first).
export const calendarWeekDays = [
  { id: 1, label: 'D' },
  { id: 2, label: 'S' },
  { id: 3, label: 'T' },
  { id: 4, label: 'Q' },
  { id: 5, label: 'Q' },
  { id: 6, label: 'S' },
  { id: 7, label: 'S' },
];

// Sunday is the first day of the week in Brazil.
export const FIRST_DAY_OF_WEEK = 0;

// vue-datepicker-next `lang` config for pt-BR.
export const datePickerLang = {
  formatLocale: {
    months: [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
    ],
    monthsShort: [
      'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
      'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez',
    ],
    weekdays: [
      'Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira',
      'Quinta-feira', 'Sexta-feira', 'Sábado',
    ],
    weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    weekdaysMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    firstDayOfWeek: FIRST_DAY_OF_WEEK,
    firstWeekContainsDate: 1,
  },
  days: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  months: [
    'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
    'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez',
  ],
  pickers: ['próximos 7 dias', 'próximos 30 dias', 'últimos 7 dias', 'últimos 30 dias'],
  placeholder: {
    date: 'Selecionar data',
    dateRange: 'Selecionar período',
  },
  yearFormat: 'YYYY',
  monthFormat: 'MMM',
  monthBeforeYear: false,
};

export const formatDate = (date, fmt = DATE_FORMAT) =>
  format(date, fmt, { locale: ptBR });

export const formatUnixDate = (unixTime, fmt = DATE_FORMAT) =>
  format(fromUnixTime(unixTime), fmt, { locale: ptBR });
